import { X, Search } from "lucide-react";
import React from "react";

type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  onEnter?: () => void;
  variant?: "default" | "soft" | "compact" | "flat" | "pill";
};

export default function SearchInput({
  value, onChange, placeholder = "Поиск…", className = "", disabled, onEnter, variant = "default",
}: Props) {
  const variantClassName: Record<NonNullable<Props["variant"]>, string> = {
    default: "rounded-2xl border border-slate-200 bg-white shadow-sm focus-within:border-slate-300 focus-within:shadow-md",
    soft: "rounded-2xl border border-indigo-100 bg-indigo-50/60 shadow-inner focus-within:border-indigo-200 focus-within:bg-white focus-within:shadow-sm",
    compact: "rounded-xl border border-slate-200 bg-white shadow-none focus-within:border-slate-400 focus-within:ring-2 focus-within:ring-slate-100",
    flat: "rounded-2xl border border-transparent bg-slate-100 shadow-none focus-within:border-slate-200 focus-within:bg-white",
    pill: "rounded-full border border-slate-200 bg-white shadow-sm focus-within:border-indigo-200 focus-within:ring-4 focus-within:ring-indigo-50",
  };
  const inputClassName = variant === "compact" ? "py-3 rounded-xl" : variant === "pill" ? "py-3 rounded-full" : "py-[14px] rounded-2xl";

  return (
    <div
      className={[
        "relative group",
        "w-full",
        variantClassName[variant],
        className,
      ].join(" ")}
    >
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
      <input
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        onKeyDown={(e) => { if (e.key === "Enter" && onEnter) onEnter(); }}
        className={["w-full bg-transparent outline-none pl-10 pr-10 text-[15px] placeholder:text-slate-400", inputClassName].join(" ")}
      />
      {value && !disabled && (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Очистить"
          className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-xl text-slate-400 hover:bg-slate-100"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
